import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconItalic: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconItalic"><Path d="M9.41406 3.5L14.5003 3.5L19.5003 3.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.5 20.5H9.5L14.5862 20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M14.4234 3.75171L9.57031 20.2524" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconItalic;
